import { z } from 'zod';
import { baseObjectSchema, baseSchema } from '../baseSchemas';

export const getSalesPersonsDCSchema = z.array(
  baseObjectSchema.extend({
    salesPersonID: z.string(),
    distributionChannelID: z.string(),
    updateUserID: z.string(),
    salesPerson: baseSchema,
    updateUser: z
      .object({
        id: z.string(),
        userName: z.string(),
      })
      .optional(),
    distributionChannel: z.any().optional(),
  })
);

export type GetSalesPersonsDCResponse = z.infer<typeof getSalesPersonsDCSchema>;
